import { render } from "./CustomBundleLayout.vue?vue&type=template&id=545ed2be&scoped=true"
import script from "./CustomBundleLayout.vue?vue&type=script&lang=js"
export * from "./CustomBundleLayout.vue?vue&type=script&lang=js"

import "./CustomBundleLayout.vue?vue&type=style&index=0&id=545ed2be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-545ed2be"]])

export default __exports__